import { CustomBuilderComponent } from '@/components/CustomBuilderComponent'
import { BUILDER_PAGE_MODEL } from '@/config/builder'
import { getStaticContentData } from '@/server/services/builder/static-content'

export const getServerSideProps = async () => {
  const data = await getStaticContentData<{ 'userAttributes.urlPath': string }>(
    BUILDER_PAGE_MODEL,
    {
      'userAttributes.urlPath': '/builder/app/politica-de-privacidade',
    },
  )
  return {
    notFound: !data,
    props: { data, url: '/app/politica-de-privacidade/' },
  }
}

export default CustomBuilderComponent
